import axios from "axios"

export const downloadFile = async (url, filename) => {
  await axios
    .get(url, {
      responseType: 'arraybuffer',
      headers: {
        'Accept': 'application/*'
      }
    })
    .then(response => {
      let blob = new Blob([response.data], { type: 'application/*' })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      link.click()
    })
    .catch(err => {
      console.error(err)
    })
}

export const downloadPrintingInformation = async (documentIdentifier, exhibitionSlug, filename) => {
  await downloadFile('/' + exhibitionSlug + '/download/printing-information/' + documentIdentifier, filename)
}